import type { ReactNode } from 'react';
import { hasAccess, type AccessLevel } from '@gdec/shared';
import { useCurrentUser } from '@/auth/AuthContext';
import { EmptyState } from './EmptyState';

/**
 * Hides a route the signed-in user may not open. This is a courtesy, not a
 * control — every one of these areas is re-authorised server-side in the
 * function allowlist, because the browser is not the security boundary.
 */
export function RequireAccess({
  allow,
  children,
}: {
  allow: readonly AccessLevel[];
  children: ReactNode;
}): ReactNode {
  const user = useCurrentUser();
  if (hasAccess(user, allow)) return <>{children}</>;

  return (
    <div className="panel">
      <EmptyState
        icon="🔒"
        title="You don't have access to this area."
        description="Your system access level does not include this queue. Contact Main Access if you believe this is wrong."
      />
    </div>
  );
}
